import { useState } from 'react';
import { ActionSheet, ActionSheetItem } from '@vkontakte/vkui';
import type { SeatingTable } from '../../types';
import type { Warning } from '../../utils/seatingWarnings';

const LEVEL_GLYPH: Record<Warning['level'], string> = {
  error: '⚠',
  warning: '⚠',
  info: 'ℹ',
};

const SEVERITY: Record<Warning['level'], number> = { error: 3, warning: 2, info: 1 };

interface TableWarningsProps {
  table: SeatingTable;
  warnings: Warning[];
  onReassignPairs: (t: SeatingTable) => void;
  onOpenGuests: (t: SeatingTable) => void;
}

export default function TableWarnings({ table, warnings, onReassignPairs, onOpenGuests }: TableWarningsProps) {
  const [menu, setMenu] = useState(false);
  const [anchor, setAnchor] = useState<Element | null>(null);
  if (warnings.length === 0) return null;

  const worst = warnings.reduce((a, w) => (SEVERITY[w.level] > SEVERITY[a] ? w.level : a), 'info' as Warning['level']);
  const hasSplit = warnings.some((w) => w.code === 'split_couple');

  return (
    <>
      <button
        type="button"
        className={`st-warn-badge st-warn-badge--${worst}`}
        ref={(el) => setAnchor(el)}
        onClick={() => setMenu(true)}
        aria-label={`Предупреждения: ${warnings.length}`}
      >
        <span aria-hidden="true">{LEVEL_GLYPH[worst]}</span>
        {warnings.length}
      </button>

      {menu && (
        <ActionSheet
          mode="sheet"
          title="Предупреждения"
          description={
            <div>
              {warnings.map((w, i) => (
                <div key={i} className={`st-warn-line st-warn-line--${w.level}`}>
                  <span aria-hidden="true">{LEVEL_GLYPH[w.level]}</span> {w.text}
                </div>
              ))}
            </div>
          }
          toggleRef={anchor}
          onClosed={() => setMenu(false)}
          iosCloseItem={<ActionSheetItem mode="cancel">Отмена</ActionSheetItem>}
        >
          {hasSplit && (
            <ActionSheetItem
              onClick={() => {
                onReassignPairs(table);
              }}
            >
              Пересадить пару сюда
            </ActionSheetItem>
          )}
          <ActionSheetItem
            onClick={() => {
              onOpenGuests(table);
            }}
          >
            Открыть гостей
          </ActionSheetItem>
        </ActionSheet>
      )}
    </>
  );
}
